export const baseButtonToken = {
  root: {
    paddingX: '1.5rem',
    paddingY: '0.625rem',
    borderRadius: '0.25rem',

    // start custom
    fontSize: '0.75rem',
    lineHeight: '150%',
    // end custom
    sm: {
      paddingX: '0.75rem',
      paddingY: '0.25rem',
    },
    // lg: {
    //   paddingX: '1.25rem',
    //   paddingY: '0.5rem',
    // },

    label: {
      fontWeight: '600',
    },
    iconOnlyWidth: '2.25rem',
    badgeSize: '0.5rem',
  },
  colorScheme: {
    light: {
      root: {
        // primary button
        primary: {
          background: '{primary.500}',
          borderColor: '{primary.500}',
          color: '{surface.0}',
          hoverBackground: '{primary.700}',
          hoverBorderColor: '{primary.700}',
          hoverColor: '{surface.0}',
          activeBackground: '{primary.700}',
          activeBorderColor: '{primary.700}',
          activeColor: '{surface.0}',
          focusRing: {
            color: '{primary.700}',
            shadow: 'none',
          },

          // start custom colors
          disabled: {
            background: '{gray.100}',
            borderColor: '{gray.100}',
            color: '{surface.0}',
            opacity: '1',
            cursor: 'default',
          },
        },
        secondary: {
          background: '{surface.0}',
          hoverBackground: '{neutral.500}',
          activeBackground: '{neutral.500}',
          borderColor: '{surface.0}',
          hoverBorderColor: '{neutral.500}',
          activeBorderColor: '{neutral.500}',
          color: '{primary.700}',
          hoverColor: '{primary.700}',
          activeColor: '{primary.700}',
          focusRing: {
            color: '{primary.700}',
            shadow: 'none',
          },

          // start custom colors
          disabled: {
            background: '{surface.0}',
            borderColor: '{surface.0}',
            color: '{primary.700}',
            opacity: '0.5',
            cursor: 'default',
          },
          // end custom colors
        },
        contrast: {
          background: '{surface.0}',
          hoverBackground: 'rgba(255, 255, 255, 0.4)',
          activeBackground: 'rgba(255, 255, 255, 0.4)',
          borderColor: '{surface.0}',
          hoverBorderColor: '{primary.100}',
          activeBorderColor: '{primary.100}',
          color: '{primary.700}',
          hoverColor: '{primary.700}',
          activeColor: '{primary.700}',
          focusRing: {
            color: '{primary.700}',
            shadow: 'none',
          },

          // start custom colors
          disabled: {
            background: '{surface.0}',
            borderColor: '{surface.0}',
            color: '{primary.700}',
            opacity: '0.5',
            cursor: 'default',
          },
          // end custom colors
        },
      },
      outlined: {
        primary: {
          background: 'transparent',
          hoverBackground: '{neutral.500}',
          activeBackground: '{neutral.500}',
          borderColor: '{primary.500}',
          hoverBorderColor: '{primary.500}',
          activeBorderColor: '{primary.400}',
          color: '{primary.500}',
          hoverColor: '{primary.500}',
          activeColor: '{primary.500}',
          focusRing: {
            color: '{primary.500}',
            shadow: 'none',
          },

          // start custom colors
          disabled: {
            background: 'transparent',
            borderColor: '{primary.500}',
            color: '{primary.500}',
            opacity: '0.5',
            cursor: 'default',
          },
        },
        secondary: {
          background: 'transparent',
          hoverBackground: '{primary.700}',
          activeBackground: '{primary.700}',
          borderColor: '{primary.700}',
          hoverBorderColor: '{primary.700}',
          activeBorderColor: '{primary.700}',
          color: '{primary.700}',
          hoverColor: '{surface.0}',
          activeColor: '{surface.0}',
          focusRing: {
            color: '{primary.700}',
            shadow: 'none',
          },

          // start custom colors
          disabled: {
            background: 'transparent',
            borderColor: '{primary.700}',
            color: '{primary.700}',
            opacity: '0.5',
            cursor: 'default',
          },
          // end custom colors
        },
        contrast: {
          background: 'transparent',
          hoverBackground: 'rgba(255, 255, 255, 0.15)',
          activeBackground: 'rgba(255, 255, 255, 0.15)',
          borderColor: '{surface.0}',
          hoverBorderColor: '{surface.0}',
          activeBorderColor: '{surface.0}',
          color: '{surface.0}',
          hoverColor: '{surface.0}',
          activeColor: '{surface.0}',
          focusRing: {
            color: '{surface.0}',
            shadow: 'none',
          },

          // start custom colors
          disabled: {
            background: 'transparent',
            borderColor: '{primary.500}',
            color: '{primary.500}',
            opacity: '0.5',
            cursor: 'default',
          },
        },
      },
      /**
       * <p-button label="Text" [text]="true" />
       */
      text: {
        primary: {
          background: 'transparent',
          borderColor: 'transparent',
          color: '{primary.500}',
          hoverBackground: '{neutral.500}',
          hoverBorderColor: '{primary.100}',
          hoverColor: '{primary.500}',
          activeBackground: '{primary.500}',
          activeBorderColor: '{primary.500}',
          activeColor: '{surface.0}',
          focusRing: {
            color: '{primary.700}',
            shadow: 'none',
          },

          // start custom colors
          disabled: {
            background: '{gray.100}',
            borderColor: '{gray.100}',
            color: '{surface.0}',
            opacity: '1',
            cursor: 'default',
          },
        },
        secondary: {
          background: 'transparent',
          borderColor: 'transparent',
          color: 'rgba(255, 255, 255, 0.8)',
          hoverBackground: 'rgba(255, 255, 255, 0.15)',
          hoverBorderColor: 'rgba(255, 255, 255, 0.15)',
          hoverColor: '{surface.0}',
          activeBackground: 'rgba(255, 255, 255, 0.15)',
          activeBorderColor: 'rgba(255, 255, 255, 0.15)',
          activeColor: '{surface.0}',
          focusRing: {
            color: '{surface.0}',
            shadow: 'none',
          },

          // start custom colors
          disabled: {
            background: 'transparent',
            borderColor: 'transparent',
            color: 'rgba(255, 255, 255, 0.8)',
            opacity: '0.5',
            cursor: 'default',
          },
        },
        contrast: {
          background: 'transparent',
          borderColor: 'transparent',
          color: '{primary.700}',
          hoverBackground: 'rgba(255, 255, 255, 0.4)',
          hoverBorderColor: '{primary.100}',
          hoverColor: '{primary.700}',
          activeBackground: 'rgba(255, 255, 255, 0.4)',
          activeBorderColor: '{primary.100}',
          activeColor: '{primary.700}',
          focusRing: {
            color: '{primary.700}',
            shadow: 'none',
          },

          // start custom colors
          disabled: {
            background: 'transparent',
            borderColor: 'transparent',
            color: '{primary.700}',
            opacity: '0.5',
            cursor: 'default',
          },
        },
        plain: {
          hoverBackground: 'transparent',
          activeBackground: 'transparent',
          color: '{surface.0}',
        },
      },
    },
  },
  css: ({ dt }: { dt: (token: string, val?: string) => string }) => `
    .p-button {
      font-size: ${dt('button.fontSize')};
      line-height: ${dt('button.lineHeight')};
    }

    .p-button-text:not(:disabled):hover {
      color: ${dt('button.text.primary.hover.color')};
    }

    .p-button-text.p-button-primary:not(:disabled):hover {
      color: ${dt('button.text.primary.hoverColor')};
      background: ${dt('button.text.primary.hoverBackground')};
      border-color: ${dt('button.text.primary.hoverBorderColor')};
    }

    .p-button-text.p-button-primary:not(.inactive):not(:disabled):active,
    .active .p-button-text.p-button-primary:not(:disabled) {
      color: ${dt('button.text.primary.activeColor')};
      background: ${dt('button.text.primary.activeBackground')};
      border-color: ${dt('button.text.primary.activeBorderColor')};
    }

    .p-button-text.p-button-contrast:not(:disabled):hover {
      color: ${dt('button.text.contrast.hoverColor')};
      background: ${dt('button.text.contrast.hoverBackground')};
      border-color: ${dt('button.text.contrast.hoverBorderColor')};
    }

    .p-button-text.p-button-contrast:not(:disabled):active,
    .active .p-button-text.p-button-contrast:not(:disabled) {
      color: ${dt('button.text.contrast.activeColor')};
      background: ${dt('button.text.contrast.activeBackground')};
      border-color: ${dt('button.text.contrast.activeBorderColor')};
    }

    .p-button-text.p-button-secondary:not(:disabled):hover {
      color: ${dt('button.text.secondary.hoverColor')};
      background: ${dt('button.text.secondary.hoverBackground')};
      border-color: ${dt('button.text.secondary.hoverBorderColor')};
    }

    .p-button-text.p-button-secondary:not(:disabled):active,
    .active .p-button-text.p-button-secondary:not(:disabled) {
      color: ${dt('button.text.secondary.activeColor')};
      background: ${dt('button.text.secondary.activeBackground')};
      border-color: ${dt('button.text.secondary.activeBorderColor')};
    }



    .p-button:disabled {
        background: ${dt('button.primary.disabled.background')};
        color: ${dt('button.primary.disabled.color')};
        border-color: ${dt('button.primary.disabled.borderColor')};
        opacity: ${dt('button.primary.disabled.opacity')};
        cursor: ${dt('button.primary.disabled.cursor')};
    }
    .p-button-secondary:disabled {
        background: ${dt('button.secondary.disabled.background')};
        color: ${dt('button.secondary.disabled.color')};
        border-color: ${dt('button.secondary.disabled.borderColor')};
        opacity: ${dt('button.secondary.disabled.opacity')};
        cursor: ${dt('button.secondary.disabled.cursor')};
    }

    .p-button-outlined:disabled {
      background: ${dt('button.outlined.primary.disabled.background')};
      color: ${dt('button.outlined.primary.disabled.color')};
      border-color: ${dt('button.outlined.primary.disabled.borderColor')};
      opacity: ${dt('button.outlined.primary.disabled.opacity')};
      cursor: ${dt('button.outlined.primary.disabled.cursor')};
    }
    .p-button-contrast:disabled {
      background: ${dt('button.contrast.disabled.background')};
      color: ${dt('button.contrast.disabled.color')};
      border-color: ${dt('button.contrast.disabled.borderColor')};
      opacity: ${dt('button.contrast.disabled.opacity')};
      cursor: ${dt('button.contrast.disabled.cursor')};
    }

    .p-button-outlined.p-button-secondary:disabled {
      background: ${dt('button.outlined.secondary.disabled.background')};
      color: ${dt('button.outlined.secondary.disabled.color')};
      border-color: ${dt('button.outlined.secondary.disabled.borderColor')};
      opacity: ${dt('button.outlined.secondary.disabled.opacity')};
      cursor: ${dt('button.outlined.secondary.disabled.cursor')};
    }

    .p-button-text.p-button-contrast:disabled {
      background: ${dt('button.text.contrast.disabled.background')};
      color: ${dt('button.text.contrast.disabled.color')};
      border-color: ${dt('button.text.contrast.disabled.borderColor')};
      opacity: ${dt('button.text.contrast.disabled.opacity')};
      cursor: ${dt('button.text.contrast.disabled.cursor')};
    }

    .p-button-text.p-button-secondary:disabled {
      background: ${dt('button.text.secondary.disabled.background')};
      color: ${dt('button.text.secondary.disabled.color')};
      border-color: ${dt('button.text.secondary.disabled.borderColor')};
      opacity: ${dt('button.text.secondary.disabled.opacity')};
      cursor: ${dt('button.text.secondary.disabled.cursor')};
    }

    .p-button.activated.p-button-text.p-button-secondary,
    p-button.activated .p-button-text.p-button-secondary {
      color: ${dt('button.text.secondary.hoverColor')};
      background: ${dt('button.text.secondary.hoverBackground')};
    }

    .p-button-outlined:not(:disabled):hover {
      background: ${dt('button.outlined.primary.hoverBackground')};
      color: ${dt('button.outlined.primary.hoverColor')};
      border-color: ${dt('button.outlined.primary.hoverBorderColor')};
    }
    .p-button-outlined:not(:disabled):active,
    .active .p-button-outlined:not(:disabled):active {
      background: ${dt('button.outlined.primary.activeBackground')};
      color: ${dt('button.outlined.primary.activeColor')};
      border-color: ${dt('button.outlined.primary.activeBorderColor')};
    }
    .p-button-outlined.p-button-secondary:not(:disabled):hover {
      background: ${dt('button.outlined.secondary.hoverBackground')};
      color: ${dt('button.outlined.secondary.hoverColor')};
      border-color: ${dt('button.outlined.secondary.hoverBorderColor')};
    }
    .p-button-outlined.p-button-secondary:not(:disabled):active,
    .active .p-button-outlined.p-button-secondary:not(:disabled) {
      background: ${dt('button.outlined.secondary.activeBackground')};
      color: ${dt('button.outlined.secondary.activeColor')};
      border-color: ${dt('button.outlined.secondary.activeBorderColor')};
    }
    `,
};
